__turbopack_context__.v({
  "chipRow": "stubs-module-scss-module__83VQRq__chipRow",
  "pageRow": "stubs-module-scss-module__83VQRq__pageRow",
  "section": "stubs-module-scss-module__83VQRq__section",
  "spread": "stubs-module-scss-module__83VQRq__spread",
  "stack": "stubs-module-scss-module__83VQRq__stack",
  "stackSm": "stubs-module-scss-module__83VQRq__stackSm",
  "stackXs": "stubs-module-scss-module__83VQRq__stackXs",
});
